/**
 * Persistent visitor identifier.
 *
 * A random UUID stored in localStorage so the same browser is recognisable
 * across sessions on this generator's origin. Used to measure returning users
 * without collecting any PII. Not shared across generator apex domains
 * (each subdomain has its own localStorage).
 */
const STORAGE_KEY = "lv_visitor_id";

let cached: string | null = null;

export function getVisitorId(): string {
  if (cached) return cached;
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing && /^[0-9a-f-]{16,}$/i.test(existing)) {
      cached = existing;
      return existing;
    }
    const fresh = crypto.randomUUID();
    window.localStorage.setItem(STORAGE_KEY, fresh);
    cached = fresh;
    return fresh;
  } catch {
    // Private mode / storage disabled — fall back to an ephemeral id.
    if (!cached) cached = crypto.randomUUID();
    return cached;
  }
}